import React, { useState } from "react";
import axios from "axios";
import {
    Row,
    Col,
    Card,
    Button,
    Form,
    Alert,
    Spinner,
    Table,
} from "react-bootstrap";
import PageLayout from "../../../layouts/PageLayout";
import { Link } from "react-router-dom";

function SearchPerson() {
    const [cnic, setCnic] = useState("");
    const [number, setNumber] = useState("");
    const [name, setName] = useState("");
    const [result, setResult] = useState([]);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const AuthToken = localStorage.getItem("AuthUser");
    axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;
    const handleSearch = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        setResult([]);

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/search`,
                {
                    cnic,
                    number,
                    name,
                }
            );

            if (response.data.success) {
                // If name search (multiple results)
                if (response.data.data) {
                    setResult(response.data.data);
                }
                // If single record
                else {
                    setResult([
                        {
                            f_number: response.data.f_number,
                            cnic: response.data.cnic,
                            beneficiary_name: response.data.beneficiary_name,
                        },
                    ]);
                }
            } else {
                setError(response.data.error);
            }
        } catch (err) {
            setError("Server Error");
        }

        setLoading(false);
    };

    return (
        <PageLayout>
            {/* Breadcrumb */}
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className="mc-breadcrumb">
                            <h3 className="mc-breadcrumb-title">
                                <i className="material-icons">search</i>
                                Search Family
                            </h3>
                            <ul className="mc-breadcrumb-list">
                                <li className="mc-breadcrumb-item">
                                    <Link
                                        to="/"
                                        className="mc-breadcrumb-link"
                                        style={{ color: "#077834" }}
                                    >
                                        Home
                                    </Link>
                                </li>
                                <li className="mc-breadcrumb-item">Search Family</li>
                            </ul>
                        </div>
                    </div>
                </Col>
            </Row>

            {/* Search Form */}
            <Row className="justify-content-center mt-4">
                <Col md={8}>
                    <Card border="success">
                        <Card.Header className="bg-success">
                            <h5 className="mb-0 text-white">Search Family</h5>
                        </Card.Header>

                        <Card.Body>
                            <Form onSubmit={handleSearch}>
                                {/* CNIC */}
                                <Form.Group className="mb-3">
                                    <Form.Label>CNIC</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter CNIC"
                                        value={cnic}
                                        onChange={(e) => setCnic(e.target.value)}
                                    />
                                </Form.Group>

                                {/* F Number */}
                                <Form.Group className="mb-3">
                                    <Form.Label>F Number</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter FSF-ID"
                                        value={number}
                                        onChange={(e) => setNumber(e.target.value)}
                                    />
                                </Form.Group>

                                {/* Name */}
                                <Form.Group className="mb-3">
                                    <Form.Label>Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter Name"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                    />
                                </Form.Group>

                                <div className="d-grid">
                                    <Button
                                        variant="success"
                                        type="submit"
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <>
                                                <Spinner
                                                    animation="border"
                                                    size="sm"
                                                    className="me-2"
                                                />
                                                Searching...
                                            </>
                                        ) : (
                                            "Search"
                                        )}
                                    </Button>
                                </div>
                            </Form>

                            {/* Error Alert */}
                            {error && (
                                <Alert variant="danger" className="mt-3">
                                    {error}
                                </Alert>
                            )}

                            {/* Results Table */}
                            {result.length > 0 && (
                                <div className="mt-4">
                                    <h5 className="text-success mb-3">
                                        Search Results ({result.length})
                                    </h5>

                                    <Table striped bordered hover responsive>
                                        <thead className="table-success">
                                            <tr>
                                                <th>#</th>
                                                <th>F Number</th>
                                                <th>CNIC</th>
                                                <th>Beneficiary Name</th>
                                                <th>View Report</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {result.map((person, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{person.f_number}</td>
                                                    <td>{person.cnic}</td>
                                                    <td>{person.beneficiary_name}</td>
                                                    <td>
                                                        <Link
                                                            to={`/family-report/${person.f_number}`}
                                                            variant="outline-primary"
                                                            size="sm"
                                                           
                                                        >
                                                            View Report
                                                        </Link>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            )}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </PageLayout>
    );
}

export default SearchPerson;
